import * as React from 'react';

import Workflow32 from './Workflow32';

export const workflow32 = () => <Workflow32 />;

export default {
    title: 'Icon/Content/Workflow32',
    component: Workflow32,
    parameters: {
        notes: "`import Workflow32 from 'box-ui-elements/es/icon/content/Workflow32';`",
    },
};
